/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import { PHOTO_PATH } from "../../config";

const validator = require("validator");

export const checkS3URL = (link) => {
  try {
    return link.match(PHOTO_PATH) != null;
  } catch (e) {
    return false;
  }
};

export const checkURL = (url) => {
  if (isEmpty(url)) return true; //can be null
  return validator.isURL(url, {
    protocols: ["http", "https"],
    require_protocol: true,
  });
};

export const checkEmail = (value) => {
  return validator.isEmail(value);
};

export const isEmpty = (value) => {
  if (value === undefined) return true;
  return validator.isEmpty(String(value));
};

export const isLength = (value, max, min) => {
  return validator.isLength(value, { max: max, min: min });
};

export const isNumber = (no, min, max, bool) => {
  let no_symbols = false;
  if (bool) no_symbols = bool;
  if (
    !validator.isNumeric(String(no), {
      no_symbols: no_symbols,
    })
  )
    return false;
  if (min) {
    if (no < min) return false;
  }
  if (max) {
    if (no > max) return false;
  }

  return true;
};

export const username = (err) => {
  return {
    name: "email",
    check: true,
    required: true,
    customFunc: (email) => {
      if (err !== "") {
        return false;
      }
      return checkEmail(email);
    },
  };
};

export const password = (err) => {
  return {
    name: "password",
    check: true,
    required: true,
    min: 8,
    customFunc: (password) => {
      if (err === "") {
        return true;
      }
    },
  };
};
